type DatasetEntry = {
  dateTime: Date;
  forwardBreakingGForces: number | null;
  sideTosideGForces: number | null;
  speed: number | null;
};

export const interpolateAccidentStatusData = (data: DatasetEntry[]) => {
  const getTime = (entry: DatasetEntry) => entry.dateTime.getTime();

  const knownPointsF = data
    .map((entry, index) => ({ ...entry, time: getTime(entry), index }))
    .filter(entry => entry.forwardBreakingGForces !== null);

  const knownPointsS = data
    .map((entry, index) => ({ ...entry, time: getTime(entry), index }))
    .filter(entry => entry.sideTosideGForces !== null);

  const knownPointsSpeed = data
    .map((entry, index) => ({ ...entry, time: getTime(entry), index }))
    .filter(entry => entry.speed !== null);

  const interpolate = (x: number, x0: number, y0: number, x1: number, y1: number) => {
    if (x1 === x0) return y0; // Avoid division by zero
    return y0 + ((y1 - y0) * (x - x0)) / (x1 - x0);
  };

  const findSurroundingPoints = (
    x: number,
    knownPoints: {
      time: number;
      index: number;
      forwardBreakingGForces: number | null;
      sideTosideGForces: number | null;
      speed: number | null;
    }[],
  ) => {
    let prev = null,
      next = null;

    for (let j = 0; j < knownPoints.length; j++) {
      if (knownPoints[j].time < x) prev = knownPoints[j];
      if (knownPoints[j].time > x) {
        next = knownPoints[j];
        break;
      }
    }
    return { prev, next };
  };

  return data.map(entry => {
    if (
      entry.forwardBreakingGForces !== null &&
      entry.sideTosideGForces !== null &&
      entry.speed !== null
    ) {
      return entry;
    }

    const time = getTime(entry);

    const { prev: prevF, next: nextF } = findSurroundingPoints(time, knownPointsF);
    const { prev: prevS, next: nextS } = findSurroundingPoints(time, knownPointsS);
    const { prev: prevSpeed, next: nextSpeed } = findSurroundingPoints(time, knownPointsSpeed);

    return {
      ...entry,
      forwardBreakingGForces:
        entry.forwardBreakingGForces !== null || !prevF || !nextF
          ? entry.forwardBreakingGForces
          : interpolate(
              time,
              prevF.time,
              prevF.forwardBreakingGForces!,
              nextF.time,
              nextF.forwardBreakingGForces!,
            ),
      sideTosideGForces:
        entry.sideTosideGForces !== null || !prevS || !nextS
          ? entry.sideTosideGForces
          : interpolate(
              time,
              prevS.time,
              prevS.sideTosideGForces!,
              nextS.time,
              nextS.sideTosideGForces!,
            ),
      speed:
        entry.speed !== null || !prevSpeed || !nextSpeed
          ? entry.speed
          : interpolate(time, prevSpeed.time, prevSpeed.speed!, nextSpeed.time, nextSpeed.speed!),
    };
  });
};
